'use client'

import { createContext, useContext } from 'react'

import { RequestUserAgent } from '@/types/global'

// Other props that need to keep consistent state during SSR and client hydration can be added here
export interface SsrContextProps {
  requestUserAgent: RequestUserAgent
  selectedCurrency: string
  countryCode: string
  regionCode: string
}

const SsrContext = createContext<SsrContextProps | null>(null)
export default SsrContext

export const useSsrContext = () => useContext(SsrContext) ?? ({} as SsrContextProps)

/**
 * Render correct device view according to the user agent in SSR and client hydration
 * @returns
 */
export const useSsrUserAgentDevice = () => useSsrContext().requestUserAgent.device.kind
